<!-- We use h2 elements but with the h3 CSS, because in the design we need the h3 styling but the h2 tag is required for SEO purposes -->
<h2 class="delivery-anchors-title">{{ title }}</h2>
<div class="delivery-anchors-container">
  <a *ngFor="let anchor of anchors" [routerLink]="anchor.link" (click)="onLinkClick(anchor.link)" class="delivery-anchors__anchor">{{ anchor.text }}</a>
</div>
